import React, { useRef, useState, useEffect } from 'react';
import $ from 'jquery';
import countriesList from 'iso-3166-1-alpha-2';
import { useDispatch } from 'react-redux';
import appartement from './../../../../../assets/images/svg/090-flats.svg';
import maison from './../../../../../assets/images/svg/069-home.svg';
import palace from './../../../../../assets/images/svg/093-palace.svg';
import hotel from './../../../../../assets/images/svg/087-hotel.svg';
import peniche from './../../../../../assets/images/svg/091-house-2.svg';
import divers from './../../../../../assets/images/svg/092-camping-tent.svg';
import residenceSenior from "./../../../../../assets/images/svg/147-senior-residence.svg";

import { RegexFields } from './../../../../../constants/utils/regexFields';
import {updateDeathDeclaration} from '../../../../../actions/facilita-api';
import * as loadings from '../../../../../constants/loadings/facilita/deathDeclaration';
import { PostalCityInput } from "./../../../../../_common/postalCityInput";


export const ModalAddress = ({deathDeclaration, userId, isLoading}) => {
    const dispatch = useDispatch();
    var countries = require("i18n-iso-countries");
    countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
    const addressForm = useRef(null);
    const [wasValidated, setWasValidated] = useState(false);
    const [asset, setAsset] = useState({
        address: deathDeclaration.userResidenceAddress.addressLine1,
        type: deathDeclaration.userResidenceAddress.addressContract,
        estateType: deathDeclaration.userResidenceAddress.addressType,
        city: deathDeclaration.userResidenceAddress.city,
        country: deathDeclaration.userResidenceAddress.country,
        postalCode: deathDeclaration.userResidenceAddress.postalCode,
    });
    useEffect(() => {
        $('[data-toggle="tooltip"]').tooltip();
    }, []);

    return (
			<div className="modal fade px-0" id="addressModal" aria-labelledby="addressModalLabel" aria-hidden="true">
				<div className="modal-dialog px-2 container-screen">
					<div className="modal-content">
						<div className="modal-header" data-dismiss="modal" aria-label="Close">
							<div className="alert bg-common rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
								<h1 className="sr-only visually-hidden">Information deceased</h1>
								<div className="h4 text-primary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1" id="addressModalLabel">
									modifier les champs
								</div>
							</div>
						</div>
						<div className="modal-body scroll-default py-0">
							<p className="o-60 pt-3">Modifier les informations qui ne sont pas à jour.</p>
							<form className="flex-column" ref={addressForm}>
								{/* <div className="form-group">
                                <label className="h6 font-weight-bolder" htmlFor="processus">TYPE DE BIEN</label>
                                <div className="form-inline mb-0">
                                    <div className="custom-control custom-radio custom-control-inline mr-6">
                                        <input type="radio" id="Propriétaire" name="bientype" className="custom-control-input" />
                                        <label className="custom-control-label" htmlFor="Propriétaire">Propriétaire</label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline mr-6">
                                        <input type="radio" id="Locataire" name="bientype" className="custom-control-input" checked="checked" />
                                        <label className="custom-control-label" htmlFor="Locataire">Locataire</label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input type="radio" id="Autre" name="bientype" className="custom-control-input" />
                                        <label className="custom-control-label" htmlFor="Autre">Autre</label>
                                    </div>
                                </div>
                            </div> */}

								<div className="form-group mb-4">
									<h5 className="h6 font-weight-bolder">TYPE DE BIEN</h5>
									<div className="form-inline mb-0">
										<div className="custom-control custom-radio custom-control-inline mr-6">
											<input type="radio" id="Propriétaire" name="bientype" className="custom-control-input" checked={asset.type === 1} onChange={() => setAsset({ ...asset, type: 1 })} />
											<label className="custom-control-label" htmlFor="Propriétaire">
												Propriétaire
											</label>
										</div>
										<div className="custom-control custom-radio custom-control-inline mr-6">
											<input type="radio" id="Locataire" name="bientype" className="custom-control-input" checked={asset.type === 2} onChange={() => setAsset({ ...asset, type: 2 })} />
											<label className="custom-control-label" htmlFor="Locataire">
												Locataire
											</label>
										</div>
										<div className="custom-control custom-radio custom-control-inline">
											<input type="radio" id="Autre" name="bientype" className="custom-control-input" checked={asset.type === 3} onChange={() => setAsset({ ...asset, type: 3 })} />
											<label className="custom-control-label" htmlFor="Autre">
												Autre
											</label>
										</div>
									</div>
									<div className={"invalid-feedback alert-danger alert" + (asset.type === undefined && wasValidated === true ? " d-block" : "")}>Veuillez choisir une option</div>
								</div>
								<div className="form-group mb-0">
									<h5 className="h6 font-weight-bolder text-uppercase">type de bien immobilier</h5>
									<div className="form-row mb-3">
										<div className="form-group col col-lg-4 col-xl">
											<div className={"card card-body text-center picker-card" + (asset.estateType === 1 ? " active" : "")} onClick={() => setAsset({ ...asset, estateType: 1 })}>
												<img className="img-fluid mx-auto my-3 mb-2 h-6" src={appartement} alt="appartement" />
												<h2 className="h6 font-weight-bolder text-uppercase mb-auto">Appartement</h2>
											</div>
										</div>
										<div className="form-group col col-lg-4 col-xl">
											<div className={"card card-body text-center picker-card" + (asset.estateType === 2 ? " active" : "")} onClick={() => setAsset({ ...asset, estateType: 2 })}>
												<img className="img-fluid mx-auto my-3 mb-2 h-6" src={maison} alt="maison" />
												<h2 className="h6 font-weight-bolder text-uppercase mb-auto">Maison</h2>
											</div>
										</div>
										{/* <div className="form-group col col-lg-4 col-xl">
											<div className={"card card-body text-center picker-card" + (asset.estateType === 3 ? " active" : "")} onClick={() => setAsset({ ...asset, estateType: 3 })}>
												<img className="img-fluid mx-auto my-3 mb-2 h-6" src={palace} alt="palace" />
												<h2 className="h6 font-weight-bolder text-uppercase mb-auto">château</h2>
											</div>
										</div> */}
										<div className="form-group col col-lg-4 col-xl">
											<div className={"card card-body text-center picker-card" + (asset.estateType === 7 ? " active" : "")} onClick={() => setAsset({ ...asset, estateType: 7 })}>
												<img className="img-fluid mx-auto my-3 mb-2 h-6" src={residenceSenior} alt="senior residence" />
												<h2 className="h6 font-weight-bolder text-uppercase mb-auto">Résidence Senior</h2>
											</div>
										</div>
										<div className="form-group col col-lg-4 col-xl">
											<div className={"card card-body text-center picker-card" + (asset.estateType === 4 ? " active" : "")} onClick={() => setAsset({ ...asset, estateType: 4 })}>
												<img className="img-fluid mx-auto my-3 mb-2 h-6" src={hotel} alt="hotel" />
												<h2 className="h6 font-weight-bolder text-uppercase mb-auto">Hôtel</h2>
											</div>
										</div>
										{/* <div className="form-group col col-lg-4 col-xl">
											<div className={"card card-body text-center picker-card" + (asset.estateType === 5 ? " active" : "")} onClick={() => setAsset({ ...asset, estateType: 5 })}>
												<img className="img-fluid mx-auto my-3 mb-2 h-6" src={peniche} alt="peniche" />
												<h2 className="h6 font-weight-bolder text-uppercase mb-auto">Péniche</h2>
											</div>
										</div> */}
										<div className="form-group col col-lg-4 col-xl">
											<div className={"card card-body text-center picker-card" + (asset.estateType === 6 || asset.estateType === 3 || asset.estateType === 5 ? " active" : "")} onClick={() => setAsset({ ...asset, estateType: 6 })}>
												<img className="img-fluid mx-auto my-3 mb-2 h-6" src={divers} alt="divers" />
												<h2 className="h6 font-weight-bolder text-uppercase mb-auto">divers</h2>
											</div>
										</div>
										<div className={"invalid-feedback alert-danger alert" + (asset.estateType === undefined && wasValidated === true ? " d-block" : "")}>Veuillez choisir une option</div>
									</div>
									<div className="form-row">
										<div className="form-group col-12">
											<div className="flex-row gx-2 align-items-center mb-1">
												<label className="h6 font-weight-bolder my-auto" htmlFor="Adresse">
													Adresse
												</label>
												{/* <p className="form-text small text-gray my-auto ml-auto" data-toggle="tooltip" data-placement="top" data-html="true" data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>' title="L'adresse de l'organisme est nécessaire afin de pouvoir le contacter et d'effectuer les démarches."><i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i></p> */}
											</div>
											<input
												required
												type="text"
												className="form-control"
												id="Adresse"
												defaultValue={asset.address}
												onChange={(event) => {
													setAsset({ ...asset, address: event.target.value });
												}}
											/>
										</div>
										<PostalCityInput
											postalCode={asset.postalCode}
											city={asset.city}
											onChange={(updatedAddress) => setAsset({ ...asset, postalCode: updatedAddress.postalCode, city: updatedAddress.city })}
											hasWrapper={false}
											country={asset.country}
											customClasses={{ city: "form-group col-md", postalCode: "form-group col-md" }}
										/>
										{/* <div className="form-group col-md">
											<label className="h6 font-weight-bolder my-auto" htmlFor="Postal">
												Code Postal
											</label>
											{asset.country === null || asset.country === "FR" || asset.country === "GF" || asset.country === "PF" || asset.country === "TF" ? (
												<input
													required
													type="text"
													className="form-control"
													id="Postal"
													value={asset.postalCode}
													onChange={(event) => {
														setAsset({ ...asset, postalCode: event.target.value });
													}}
													pattern={RegexFields.frenchZipCode}
												/>
											) : (
												<input
													required
													type="text"
													className="form-control"
													id="Postal"
													value={asset.postalCode}
													onChange={(event) => {
														setAsset({ ...asset, postalCode: event.target.value });
													}}
												/>
											)}
										</div>
										<div className="form-group col-md">
											<label className="h6 font-weight-bolder my-auto" htmlFor="Ville">
												Ville
											</label>
											<input
												required
												type="text"
												className="form-control"
												id="Ville"
												defaultValue={asset.city}
												onChange={(event) => {
													setAsset({ ...asset, city: event.target.value });
												}}
												pattern={RegexFields.nameWithoutNumbers}
											/>
										</div> */}
										<div className="col-12 d-lg-none"></div>
										<div className="form-group col-md">
											<label className="h6 font-weight-bolder my-auto" htmlFor="Pays">
												Pays
											</label>
											<select
												className="custom-select"
												id="naturalite"
												tabIndex={-98}
												value={asset.country}
												onChange={(event) => {
													setAsset({ ...asset, country: event.target.value });
												}}>
												{Object.keys(countriesList.getData()).map((country, index) => {
													return (
														<option key={index} value={country}>
															{countries.getName(country, "fr", { select: "official" })}
														</option>
													);
												})}
											</select>
										</div>
									</div>
								</div>
							</form>
						</div>
						<div className="modal-footer">
							<button type="button" className="btn btn-light mr-2" data-dismiss="modal">
								Fermer
							</button>

							{isLoading.includes(loadings.UPDATING_DECLARATION) ? (
								<button type="button" className="btn btn-info loading-btn show">
									<div className="loading loading-spinner spinner-border spinner-border-sm mr-2"></div>Sauvegarder
								</button>
							) : (
								<button
									type="button"
									className="btn btn-info"
									onClick={(e) => {
										e.preventDefault();
										addressForm.current.classList.add("was-validated");
										if (addressForm.current.checkValidity()) {
											dispatch(
												updateDeathDeclaration(userId, {
													...deathDeclaration,
													userResidenceAddress: {
														...deathDeclaration.userResidenceAddress,
														addressLine1: asset.address,
														addressContract: asset.type,
														addressType: asset.estateType,
														city: asset.city,
														country: asset.country,
														postalCode: asset.postalCode,
													},
												})
											).then(() => $(".modal").modal("hide"));
										}
									}}>
									Sauvegarder
								</button>
							)}
						</div>
					</div>
				</div>
			</div>
		);
}